import React, { useState, useEffect, useRef } from "react";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import { useNavigate, useParams } from "react-router-dom";
import { getItemToken } from "../../../Utils/localStorageUtils";
import axios from "axios";
import { toast } from "react-toastify";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import saveCustomFieldsStrict from "../../../CustomFields/saveCustomFieldsStrict";

const EditPurchasePlan = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const baseURL = process.env.REACT_APP_Baseurl
  const headers = getItemToken('access_token')
  const labelSource = 'in-app-purchase'

  const addApi = `${baseURL}/admin/inapp-purchase/store`
  const editApi = `${baseURL}/admin/inapp-purchase/edit`
  const updateApi = `${baseURL}/admin/inapp-purchase/update`
  const labelApi = `${baseURL}/admin/Label-Management/list-source?source=${labelSource}`
  const currencyDefault = `${baseURL}/admin/currency_setting/index`

  const combinedRef = useRef({
    plan_price: null,
    product_id: null,
  });

  const [formData, setFormData] = useState({
    state: "formData",
    plan_price: "",
    product_id: "",
    enable: 1,
  })
  const [formDataError, setFormDataError] = useState({
    plan_price: "",
    product_id: "",
  })

  const [labelDisplay, setLabelDisplay] = useState([]);
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [showOverlay, setShowOverlay] = useState(false);
  const [symbol, setSymbol] = useState("");
  const [customFieldValues, setCustomFieldValues] = useState({});


  const formValidation = () => {
    let formIsValid = true;
    if (!formData?.plan_price) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        plan_price: "Plan Price cannot be empty.",
      }));
      combinedRef.current['plan_price'].focus()
      formIsValid = false;
    }
    if (!formData?.product_id || formData.product_id.trim().length < 3) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        product_id: formData?.product_id
          ? "Product Id must be at least 3 characters."
          : "Product Id cannot be empty.",
      }));
      combinedRef.current['product_id'].focus()
      formIsValid = false;
    }
    return formIsValid;
  }

  const handleInput = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'text' || type == 'number') {
      if (type === "number" && (value === "-" || Number(value) < 0)) {
        return;
      }
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }

    if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [name]: checked ? 1 : 0,
      }));
    }
  };

  const fetchData = async () => {
    try {
      // setShowOverlay(true)
      const response = await axios.get(`${editApi}/${id}`, { headers: headers });
      const result = response?.data?.Inapp_Purchase;
      setFormData(result)
      setShowOverlay(false)
    } catch (error) {
      console.error(error);
    }
  };

  const labelFetch = async () => {
    try {
      setShowOverlay(true)
      const response = await axios.get(`${labelApi}`, { headers: headers });
      const result = response?.data?.label_management
      setLabelDisplay(result)
      setShowOverlay(false)
    }
    catch (err) {
      setShowOverlay(false)
      toast.error(err.response.data.message)

    }
  }

  const handleAdd = async () => {
    const findApi = !id ? addApi : `${updateApi}/${id}`
    const method = 'POST';
    try {
      const formDataAdd = {};
      for (const key in formData) {
        if (["product_id", "plan_price", "enable"].includes(key)) {
          formDataAdd[key] = formData[key]
        }
      }
      const response = await axios({ method: method, url: findApi, data: formDataAdd, headers: headers, });
      const result = response?.data;
      if (result?.status) {
        // save custom field values (strict)
        try {
          const entityId = id || result?.id || result?.Inapp_Purchase_id || result?.inapp_purchase_id;
          await saveCustomFieldsStrict({ baseURL, headers, entityType: 'plan', entityId, values: customFieldValues });
        } catch (e) {
          toast.error(e?.message || 'Failed to save additional fields');
          return;
        }
        toast.success(result?.message)
        if (!id) {
          navigate("/inapp-purchase");
        }
        else {
          setWithOutRefresh(!withOutRefresh)
        }
      }
      else {
        toast.error(result?.message)
      }
    }
    catch (err) {
      const errorMessage = err?.response?.data?.message
      toast.error(errorMessage)
    }
  }

  const FetchCurrency = async () => {
    const response = await axios.get(`${currencyDefault}`, { headers: headers, })
      .then((response) => {
        var result = response?.data?.CurrencySetting?.symbol;
        setSymbol(result);
      })
      .catch((error) => console.log(error));
  }

  const handleStore = (e) => {
    e.preventDefault()
    if (formValidation()) {
      handleAdd()
    }
  }

  useEffect(async () => {
    if (id) {
      await fetchData();
    }
    await FetchCurrency()
    await labelFetch();
  }, [withOutRefresh]);


  return (
    <>
      <div>
        {showOverlay && (<Response_Processing />)}
        {<AdminBackNavigation path={`${'/inapp-purchase'}`} text="Back" />}
        <AdminSaveHeader heading={!id ? labelDisplay?.[0]?.title : labelDisplay?.[8]?.title} saveText={!id ? labelDisplay?.[4]?.title : labelDisplay?.[9]?.title} saveMethod={handleStore} />
        <FormContainer>
          <LeftWrapper>
            <Wrapper>
              {/* <MessageHeading text={!id ? labelDisplay?.[7]?.title : formData?.product_id} /> */}
              <MessageLabel text={`${labelDisplay?.[1]?.title} (${symbol})`} className="mandatorySimple" />
              <AdminCustomInput type="number" name="plan_price" value={formData?.plan_price} onChange={handleInput} placeHolder="Price" min={1} maxLength={9} ref={(el) => (combinedRef.current.plan_price = el)} error={formDataError?.plan_price} restrictNumberInput />
              <MessageLabel text={labelDisplay?.[2]?.title} className="mandatorySimple" />
              <AdminCustomInput type="text" name="product_id" value={formData?.product_id} ref={(el) => (combinedRef.current.product_id = el)} onChange={handleInput} placeHolder={"Product Id"} error={formDataError?.product_id} />

              <div className="card p-3 mt-3">
                {/* <MessageHeading text="Additional Fields" /> */}
                {/* Custom fields */}
                <FieldRenderer2
                  pageIdentifier={id ? "plans.edit" : "plans.create"}
                  entityType="plan"
                  entityId={id || null}
                  text="Additional Fields"
                />
                <FieldRenderer
                  pageIdentifier={id ? "plans.edit" : "plans.create"}
                  entityType="plan"
                  entityId={id || null}
                  onChange={setCustomFieldValues}
                />
              </div>
            </Wrapper>
          </LeftWrapper>
          <RightWrapper>
            <Wrapper>
              <MessageHeading text={labelDisplay?.[10]?.title} />
              <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-6 pe-2">
                  <MessageLabel text={labelDisplay?.[11]?.title} />
                </div>
                <div className="col-6 col-md-6 ps-2 text-end">
                  <AdminSwitch name={'enable'} checked={formData?.enable == 1} onChange={handleInput} />
                </div>
              </div>
            </Wrapper>
          </RightWrapper>
          {/* <AdminCustomButton saveMethod={handleStore} type="submit" saveText={id ? "Update Plan" : "Save Plan"} className="ms-auto" loading={showOverlay} /> */}
        </FormContainer>
      </div >
    </>
  );
};

export default EditPurchasePlan;